var map = {
	"./home/deal1.jpg": "DM+Z",
	"./home/deal2.jpg": "uMNc",
	"./home/deal3.jpg": "kx0P",
	"./home/deal4.jpg": "IX1A",
	"./home/slider1.jpg": "NSMX",
	"./home/slider2.jpg": "BkM8",
	"./home/slider3.jpg": "uAlE",
	"./home/slider4.jpg": "fRiH",
	"./logo1.svg": "4FYo",
	"./products/100/100-001.jpg": "kKVN",
	"./products/100/100-002.jpg": "6PxT",
	"./products/100/100-003.jpg": "0nQx",
	"./products/100/100-004.jpg": "t+Md",
	"./shop/1.jpg": "3fXC",
	"./shop/10.jpg": "al3Y",
	"./shop/11.jpg": "THRe",
	"./shop/12.jpg": "lrF7",
	"./shop/2.jpg": "3rTd",
	"./shop/3.jpg": "pqEl",
	"./shop/4.jpg": "p6qT",
	"./shop/5.jpg": "jYSa",
	"./shop/6.jpg": "xhs4",
	"./shop/7.jpg": "4xqy",
	"./shop/8.jpg": "kVt9",
	"./shop/9.jpg": "uAOm",
	"./shop/podnosnik.jpg": "LlEx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "czpq";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*$
// module id = czpq
// module chunks = 1